import type { PenAnchorPoint } from '@/lib/elements/types/pen-anchor-point'

/** The anchor being dragged out into a curve, with handles at drag delta (`dx`, `dy`). */
export function dragHandlePoint(point: PenAnchorPoint, dx: number, dy: number): PenAnchorPoint {
  const pt = { ...point }

  if (pt.type === 'smooth') {
    // Symmetric handles: handleOut in drag direction, handleIn is its mirror
    pt.handleOut = { x: pt.x + dx, y: pt.y + dy }
    pt.handleIn = { x: pt.x - dx, y: pt.y - dy }
  } else {
    // Corner: one-sided outgoing handle only
    pt.handleOut = { x: pt.x + dx, y: pt.y + dy }
  }

  return pt
}
